<template>
  <hm-content title="">
    <div class="table-panel flex flex-between">
      <el-button type="primary" size="small" plain @click="add"
        >新增模板
      </el-button>
      <div class="text-right">
        <el-input
          clearable
          v-model.trim="searchCondition.templateName"
          placeholder="请输入模板名称"
          size="small"
          class="ipt mr10"
        ></el-input>
        <el-select
          size="small"
          clearable
          v-model="searchCondition.templateType"
          class="mr10"
          placeholder="请选择模板类别"
          filterable
        >
          <el-option label="红包发放通知" value="redMoney"></el-option>
          <el-option label="红包活动上线" value="rewardUp"></el-option>
          <el-option label="红包活动下线" value="rewardDown"></el-option>
          <el-option
            label="红包活动定时推送"
            value="dailyActivities"
          ></el-option>
        </el-select>

        <el-button type="primary" size="small" @click="search">查询</el-button>
      </div>
    </div>
    <div class="table">
      <el-table
        :data="list"
        style="width: 100%"
        stripe
        size="small"
        border
        ref="table"
      >
        <el-table-column
          header-align="center"
          align="center"
          type="index"
          label="序号"
          width="50"
          :index="index => index + (currentPage - 1) * pageSize + 1"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="模板名称"
          prop="templateName"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="templateType"
          label="消息类型"
        >
          <template slot-scope="scope">
            <div v-if="scope.row.templateType === 'redMoney'">
              红包发放通知
            </div>
            <div v-if="scope.row.templateType === 'rewardUp'">
              红包活动上线
            </div>
            <div v-if="scope.row.templateType === 'rewardDown'">
              红包活动下线
            </div>
            <div v-if="scope.row.templateType === 'dailyActivities'">
              红包活动定时推送
            </div>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="templateType"
          label="消息模式"
        >
          <template slot-scope="scope">
            <div v-if="scope.row.templateMode === 'text'">
              文本消息
            </div>
            <div v-if="scope.row.templateMode === 'img'">
              图片消息
            </div>
          </template>
        </el-table-column>

        <el-table-column
          header-align="center"
          align="center"
          prop="templateText"
          label="文本样例"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="enabledState"
          label="状态"
        >
          <template slot-scope="scope">
            <span
              :class="scope.row.enabledState === 'yes' ? 'success' : 'danger'"
            >
              {{ scope.row.enabledState === "yes" ? "启用" : "禁用" }}</span
            >
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          header-align="center"
          align="center"
          width="200"
        >
          <template slot-scope="scope">
            <div class="flex flex-center">
              <el-button
                type="text"
                size="small"
                :class="scope.row.enabledState === 'yes' ? 'danger' : 'success'"
                @click="edits(scope.row)"
              >
                {{ scope.row.enabledState === "yes" ? "禁用" : "启用" }}
              </el-button>
              <el-button type="text" size="small" @click="edit(scope.row)">
                编辑
              </el-button>
              <el-button type="text" size="small" @click="remove(scope.row)">
                删除
              </el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="hm-pagination">
      <el-pagination
        background
        :total="total"
        @current-change="paging"
        @size-change="handleSizeChange"
        layout="total, sizes, prev, pager, next, jumper"
        :current-page="currentPage"
      ></el-pagination>
    </div>
    <el-dialog
      :close-on-click-modal="false"
      title="编辑模板"
      :visible.sync="dialogVisible"
      width="1200px"
    >
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="170px"
        class="demo-ruleForm"
      >
        <el-form-item label="消息类型：" prop="templateName">
          <div v-if="ruleForm.templateType === 'redMoney'">
            红包发放通知
          </div>
          <div v-if="ruleForm.templateType === 'rewardUp'">
            红包活动上线
          </div>
          <div v-if="ruleForm.templateType === 'rewardDown'">
            红包活动下线
          </div>
          <div v-if="ruleForm.templateType === 'dailyActivities'">
            红包活动定时推送
          </div>
        </el-form-item>
        <el-form-item label="模板名称：" prop="templateName">
          {{ ruleForm.templateName }}
        </el-form-item>
        <el-form-item label="模板模式：" prop="templateMode">
          <div v-if="ruleForm.templateMode === 'text'">
            文本消息
          </div>
          <div v-if="ruleForm.templateMode === 'img'">
            图片消息
          </div>
        </el-form-item>
        <el-form-item
          label="文字展示位置："
          prop="templateMode"
          v-if="ruleForm.templateMode === 'img'"
        >
          <div v-if="ruleForm.templateImgType === 'upperPart'">
            文字在图片头部
          </div>
          <div v-if="ruleForm.templateImgType === 'lowerPart'">
            文字在图片尾部
          </div>
        </el-form-item>
        <el-form-item
          label="消息图片："
          prop="templateMode"
          v-if="ruleForm.templateMode === 'img'"
        >
          <div class="priview" v-if="ruleForm.templateImg !== ''">
            <el-image
              style="width:100%;height: 100%;"
              :src="ruleForm.templateImg"
              :preview-src-list="[ruleForm.templateImg]"
            >
            </el-image>
            <!-- <img :src="ruleForm.templateImg" alt="主图" /> -->
            <!-- <div class="opreat-wrapper flex item-center flex-center">
              <el-button type="text" @click="handleRemove">删除</el-button>
            </div> -->
          </div>
        </el-form-item>

        <el-form-item label="可用字段：" prop="templateName">
          <ul class="flex flex-wrap">
            <li
              v-for="(v, i) in msg"
              :key="i"
              @click="dd(i)"
              class="mr10 pointer"
            >
              <el-tag>{{ v.name }}({{ v.word }})</el-tag>
            </li>
          </ul>

          <div class="form-item-tip" style="color:red">
            编辑模板采用文字+可用字段的组合方式，编辑文本点击字段即可在文本对应位置插入需要动态字段形成专用模板
          </div>
          <!-- <el-input
            type="text"
            v-model.trim="ruleForm.templateName"
            clearable
            placeholder="请输入模板名称"
            size="small"
          ></el-input> -->
        </el-form-item>
        <el-form-item label="设置想要发送的消息：" prop="templateText">
          <el-input
            class="mt20"
            ref="input"
            type="textarea"
            placeholder="请输入内容"
            style="width:500px"
            v-model="ruleForm.templateText"
            maxlength="500"
            show-word-limit
            :autosize="{ minRows: 10 }"
            @blur="getCursor"
          >
          </el-input>
        </el-form-item>
        <div class="flex flex-center">
          <el-button
            type="primary"
            size="small"
            @click="submitRuleForm('ruleForm')"
            >确 认</el-button
          >
          <el-button type="primary" size="small" @click="dialogVisible = false"
            >取 消</el-button
          >
        </div>
      </el-form>
    </el-dialog>
  </hm-content>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      rules: {
        templateName: [
          {
            required: true,
            message: "请输入模板名称",
            trigger: "blur"
          },
          {
            required: true,
            min: 2,
            max: 20,
            message: "名称应大于2小于20个字",
            trigger: "blur"
          }
        ],
        templateText: {
          required: true,
          message: "请输入模板内容",
          trigger: "blur"
        },
        templateMode: {
          required: true,
          message: "请选择消息类型",
          trigger: "blur"
        },
        templateImg: {
          required: true,
          message: "请选择消息图片",
          trigger: "blur"
        },
        templateImgType: {
          required: true,
          message: "请选择文字图片显示的位置",
          trigger: "blur"
        }
      },
      ruleForm: {
        templateImgType: "",
        templateType: "",
        templateName: "",
        templateText: "",
        templateMode: "",
        templateImg: ""
      },
      dialogVisible: false,
      list: [],
      total: 0,
      currentPage: 1,
      pageSize: 10,
      searchCondition: {},
      row: {},
      msg: [],
      start: 0,
      end: 0
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {
    this.queryList();
  },
  methods: {
    resetRuleForm() {
      setTimeout(() => {
        if (this.$refs.ruleForms) {
          this.$refs.ruleForms.resetFields();
        }
      }, 0);
    },
    submitRuleForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let params = this.ruleForm;
          params.operationType = "edit";
          params.id = this.row.id;
          this.$store.dispatch("editWxMsgTemplateInfo", params).then(res => {
            if (res.code === "0") {
              this.$message({
                message: "操作成功",
                type: "success"
              });
              this.resetRuleForm();
              this.queryList();
              this.dialogVisible = false;
            }
          });
        } else {
          return false;
        }
      });
    },
    async queryRobotKeyWord() {
      let params = {
        type:
          this.ruleForm.templateType === "redMoney"
            ? "redSendWord"
            : "redActWord"
      };
      const { result } = await this.$store.dispatch(
        "queryRobotKeyWord",
        params
      );
      this.msg = result;
    },
    dd(index) {
      const result =
        this.ruleForm.templateText.substring(0, this.start) +
        `${this.msg[index].word}` +
        this.ruleForm.templateText.substring(this.end);
      this.ruleForm.templateText = result;
      this.$nextTick(() => {
        this.$refs.input.focus();
      });
    },
    getCursor(event) {
      this.start = event.target.selectionStart;
      this.end = event.target.selectionEnd;
    },
    async edits(row) {
      let params = JSON.parse(JSON.stringify(row));
      params.operationType = "disable";
      params.enabledState = params.enabledState === "yes" ? "no" : "yes";
      const { code } = await this.$store.dispatch(
        "editWxMsgTemplateInfo",
        params
      );
      if (code === "0") {
        this.$message({
          message: "操作成功",
          type: "success"
        });

        this.queryList();
      }
    },
    search() {
      this.currentPage = 1;
      this.queryList();
    },
    edit(row) {
      this.row = row;
      this.dialogVisible = true;
      for (let key in this.ruleForm) {
        this.ruleForm[key] = row[key];
      }
      this.queryRobotKeyWord();
    },
    remove(row) {
      this.$confirm(" 删除本行数据?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        let params = JSON.parse(JSON.stringify(row));
        params.operationType = "del";
        this.$store.dispatch("editWxMsgTemplateInfo", params).then(res => {
          if (res.code === "0") {
            this.$message({
              message: " 操作成功",
              type: "success"
            });
            this.queryList();
          }
        });
      });
    },
    async queryList() {
      let params = {
        pageNo: this.currentPage,
        pageSize: this.pageSize
      };
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      Object.assign(params, searchCondition);
      const { result } = await this.$store.dispatch(
        "queryWxMsgTemplateInfoList",
        params
      );
      this.list = result.records;
      this.total = result.total;
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    add() {
      this.$router.push({
        name: "SendMsgRule",
        query: {
          type: "temp"
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.priview {
  position: relative;
  width: 360px;
  height: 480px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  img {
    width: 100%;
    height: 100%;
  }
  .opreat-wrapper {
    transition: opacity 0.2s linear;
    position: absolute;
    opacity: 0;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 6px;
  }

  &:hover {
    .opreat-wrapper {
      opacity: 1;
    }
  }
}
</style>
